import Vue from 'vue'
import normalizeCss from 'normalize.css'

Vue.use(normalizeCss)
